/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['login{display:block;height:100%;background-color:#fafafa}login>.auth-page .remember-and-login-row{display:-webkit-box;display:-ms-flexbox;display:flex}login>.auth-page .remember-and-login-row>.remember-me-checkbox{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding-top:8px}login>.auth-page .remember-and-login-row>.login-button{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:right}login>.auth-page .info-row{margin:35px 0;text-align:center;color:#797979}login>.auth-page .social-icons{text-align:center}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvYXV0aC9sb2dpbi9sb2dpbi5jb21wb25lbnQuc2Nzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9hdXRoL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/auth/login/login.component.scss.ngstyle.ts